import React from "react";
import StatsRtxReport from "./Report";
import View from "common/View";
import help from "help/viewRtxStats.md";

const StatsRtx = ({returnView = null}) => (
  <View title="Retransmissions" mdHelp={help} returnView={returnView}>
    <StatsRtxReport returnView={returnView} />
  </View>
);

export default StatsRtx;
